// sliders.js - initializes sliders and scroll integrations if vendors are present
export function initSlidersAndScroll() {
    // Initialize Swiper sliders (guarded)
    if (typeof Swiper !== 'undefined') {
        try { new Swiper(".hero-slider-one", { loop: true, speed: 1500, spaceBetween: 0, slidesPerView: 1 }); } catch (e) { console.warn('hero slider init failed', e); }
    }

    // Lenis + ScrollTrigger integration
    if (typeof Lenis !== 'undefined' && typeof ScrollTrigger !== 'undefined') {
        const lenis = new Lenis({ duration: 1.8, easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)), smooth: true });
        function raf(time) { lenis.raf(time); requestAnimationFrame(raf); }
        requestAnimationFrame(raf);
        lenis.on('scroll', ScrollTrigger.update);
        if (document.querySelector('#smooth-content')) {
            ScrollTrigger.scrollerProxy("#smooth-content", {
                scrollTop(value) { return arguments.length ? lenis.scrollTo(value, { immediate: true }) : lenis.scroll; },
                getBoundingClientRect() { return { top: 0, left: 0, width: window.innerWidth, height: window.innerHeight }; },
                pinType: document.querySelector("#smooth-content").style.transform ? "transform" : "fixed"
            });
        }
        ScrollTrigger.refresh();
    }
}
